import type { IOffer } from '../../../repositories/dailyrent/entities/offer/Offer';

export function getOfferByDirection(
  offers: readonly IOffer[],
  activeOfferRealtyId: number | null | undefined,
  direction: 'prev' | 'next',
): IOffer | null {
  if (activeOfferRealtyId == null || offers.length < 2) {
    return null;
  }

  const currentIndex = offers.findIndex(offer => offer.realtyId === activeOfferRealtyId);
  if (currentIndex === -1) {
    return null;
  }

  const offset = direction === 'next' ? 1 : -1;
  // Переходим по кругу между первым и последним оффером.
  const targetIndex = (currentIndex + offset + offers.length) % offers.length;

  return offers[targetIndex];
}
